import React,{ useState } from "react";
import { useDispatch } from "react-redux";
import { exportTasks } from "actions";
import AddUpdateModal from "../BrandAddUpdateModal";

const Header = ({ onAdd, extraFilters, object_viewed_id }) => {
  const [showAddNewModal, setShowAddNewModal] = useState(false);

  const handleOpenModal = () => setShowAddNewModal(true);
  const handleCloseModal = () => setShowAddNewModal(false);

  return (
    <>
      <div className="z-1">
        <div className="d-flex justify-content-between align-items-center p-4">
          <h1 className="font-24 font-weight-s-bold m-0">Brands</h1>
          <div className="d-flex gap-2">
            <button className="add-new-btn" onClick={handleOpenModal}>
              <img
                className="me-2 add-user-icon"
                src="/assets/images/add-icon.svg"
                alt="Add New"
              />
              Add Brands
            </button>
          </div>
        </div>
      </div>
      <AddUpdateModal show={showAddNewModal} handleClose={handleCloseModal} object_viewed_id={object_viewed_id} />
    </>
  );
};

export default Header;
